export const scrolltop = () => {
    window.scrollTo({top: 0, behavior: 'smooth'});
}
